import {
  ADD_BATCH,
  EDIT_BATCH,
  LIST_BATCH,
  LIST_TRACK_BATCH,
  VIEW_BATCH,
  DELETE_BATCH,
  ADD_PARTICIPANTS,
  EDIT_PARTICIPANTS,
  LIST_PARTICIPANTS,
  LIST_PARTICIPANTSTATUS,
  VIEW_PARTICIPANTS,
  DELETE_PARTICIPANTS,
  BATCH_SUCCESS,
  BATCH_ERROR,
  SEND_INVITATION_MAIL,
  LIST_PARTICIPANTS_TRACK_BATCH,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
  editLoading :false
}

const participants = (state = initialState, action) => {
  switch (action.type) {

    // add batch
    case ADD_BATCH:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // edit batch
    case EDIT_BATCH:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list batch
    case LIST_BATCH:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // list batch track
    case LIST_TRACK_BATCH:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view batch
    case VIEW_BATCH:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete batch
    case DELETE_BATCH:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // text
    // add participants
    case ADD_PARTICIPANTS:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // edit participants
    case EDIT_PARTICIPANTS:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list participants
    case LIST_PARTICIPANTS:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

      case LIST_PARTICIPANTSTATUS:
      state = {
        ...state,
        // loading: true,
        // successMsg: null,
        // error: null,
      }
      break

     

    // list participants track batch
    case LIST_PARTICIPANTS_TRACK_BATCH:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view participants
    case VIEW_PARTICIPANTS:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete participants
    case DELETE_PARTICIPANTS:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

  // send invitation
  case SEND_INVITATION_MAIL:
    state = {
      ...state,
      successMsg: null,
      error: null,
    }
    break

  case BATCH_SUCCESS:
    state = {
      ...state,
      loading: false,
      editLoading:false,
      successMsg: action.payload,
    }
    break
  case BATCH_ERROR:
    state = { ...state, error: action.payload, loading: false,editLoading:false }
    break

  default:
    state = { ...state }
    break
  }
  return state
}

export default participants
